import { React, useState, useRef, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';
import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';
import { useLanguage } from '../../Context/LanguageContext';

import FetchModule from '../../Model/Share/Network/FetchModule';

import { ReactComponent as LeftArrowSvg } from '../../image/LeftArrow.svg';
import { ReactComponent as CheckSvg } from '../../image/Check.svg';

export default function AutoCancelSelectBox(props) {
  const { value, setValue, teacherId, setTeacherId } = props;
  const history = useHistory();
  const { isDark } = useTheme();
  const { t } = useLanguage();
  const theme = isDark ? darkTheme : lightTheme;

	const [isClicked, setIsClicked] = useState(false);
  const options = [
    { name: '시간', label: t('system.hour') },
    { name: '분',  label: t('system.min')  },
  ];

  const TopLevelRef = useRef();
	const SelectRef = useRef();

  // 컴포넌트 밖을 클릭하면 셀렉트 창 닫기
  useEffect(() => {
    document.addEventListener("mousedown", onClickOutSide);

    return () => {
      document.removeEventListener("mousedown", onClickOutSide);
    }
  }, [])

  // 컴포넌트 밖을 클릭하면 셀렉트 창 닫기
  function onClickOutSide(e) {
    if (TopLevelRef.current !== e.target && !TopLevelRef.current.contains(e.target)) {
      SelectRef.current.style.border = '0px';
      SelectRef.current.style.height = `0px`;
      SelectRef.current.style.overflow = 'hidden';
      setIsClicked(false);
    }
  }

	function onClick() {
		if (isClicked) {
			SelectRef.current.style.border = '0px';
			SelectRef.current.style.height = `0px`;
			SelectRef.current.style.overflow = 'hidden';
			setIsClicked(false);
		}
		else {
			SelectRef.current.style.border = `1px solid ${theme.primary}`;
			SelectRef.current.style.height = (32 * (options.length )) > 130 ? `130px` : ((32 * (options.length)) + 'px');
			SelectRef.current.style.overflowY = 'scroll';
			SelectRef.current.style.overflowX = 'none';
			setIsClicked(true);
		}
	}

  // 코치 클릭시
	function optionalClick(data) {
    setValue(data);
    onClick();
	}

	return (
    <TopLevelWrapper ref={TopLevelRef}>
      <DefaultView
        isClicked={isClicked}
        onClick={onClick}>
        <Option>{options.find(o => o.name === value)?.label ?? value}</Option>
        <StyledArrow isClicked={isClicked} />
      </DefaultView>
      <SelectBox
        ref={SelectRef}
        isClicked={isClicked}>
        {
          options.map((data, index) =>
            <OptionWrapper key={'Options-' + index} isClicked={value === data.name} onClick={() => optionalClick(data.name)}>
              <Option>{data.label}</Option>
              { value === data.name && <StyledCheck /> }
            </OptionWrapper>
          )
        }
      </SelectBox>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  position: relative;
	display: flex;
	flex-direction: column;

  width: 100%;
	height: 30px;
`;

const DefaultView = styled.div`
  display: flex;
	flex-direction: row;

  justify-content: space-between;
  align-items: center;

  padding: 0 8px 0 8px;

  width: calc(100% - 18px);
  height: 30px;

  z-index: 3;

	border: 1px solid ${props => props.theme.line};
	border-radius: 8px;

	background-color: ${props => props.theme.subBackground};
  color: ${props => props.theme.text};

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const StyledArrow = styled(LeftArrowSvg)`
  width: 10px;
  height: auto;
  flex-shrink: 0;

  color: ${props => props.theme.subText};
  transform: ${props => props.isClicked ? `rotate(-90deg)` : `rotate(90deg)`};
  transition: transform 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const StyledCheck = styled(CheckSvg)`
  width: 12px;
  height: 9px;
  color: ${props => props.theme.primary};
`;

const SelectBox = styled.div`
	position: absolute;
	display: flex;
	flex-direction: column;

	justify-content: flex-start;
	align-items: flex-start;

  margin-top: 40px;

  width: calc(100% - 2px);
	height: 0px;

  z-index: 2;

  border: 0px;
	border-radius: 8px;
	overflow: hidden;

	background-color: ${props => props.theme.subBackground};

  transition: all 0.3s ease-in-out;

	&:hover {
		cursor: pointer;
	}

	&::-webkit-scrollbar {
    width: 0px;
	}

	&::-webkit-scrollbar-thumb {
    box-shadow: inset 0 0 10px 20px ${props => props.theme.primary};
		border: 3px solid transparent;
		height: 25px;
		border-radius: 200px;
	}

	&::-webkit-scrollbar-track {
    box-shadow: inset 0 0 10px 10px transparent;
		border: 4px solid transparent;
		background-color: transparent;
	}

	&::-webkit-scrollbar-track-piece {
		background-color: transparent;
	}
`;

const OptionWrapper = styled.div`
	display: flex;
	flex-direction: row;

  justify-content: space-between;
  align-items: center;

	width: calc(100% - 16px);

  padding: 0 8px 0 8px;

  color: ${props => props.isClicked ? props.theme.primary : props.theme.text};

	&:hover {
		cursor: pointer;
    color: ${props => props.isClicked ? props.theme.primary : props.theme.white};
    background-color: ${props => props.isClicked ? props.theme.subBackground : props.theme.primary};
	}

  transition: all 0.3s ease-in-out;
`;

const Option = styled.p`
	font-family: NotoSansKR-Regular;
	font-size: 14px;

  margin: 6px 0 6px 0;
  padding: 0 0 0 0;
`;
